import { render } from "./ProductBanner.vue?vue&type=template&id=1de4840d&scoped=true"
import script from "./ProductBanner.vue?vue&type=script&lang=js"
export * from "./ProductBanner.vue?vue&type=script&lang=js"

import "./ProductBanner.vue?vue&type=style&index=0&id=1de4840d&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de4840d"]])

export default __exports__